// cedulaEcuador.js
// Validador de cedula ecuatoriana para Vue 2 / JavaScript sin optional chaining.

var provinciasEcuador = {
  "01": "Azuay",
  "02": "Bolivar",
  "03": "Canar",
  "04": "Carchi",
  "05": "Cotopaxi",
  "06": "Chimborazo",
  "07": "El Oro",
  "08": "Esmeraldas",
  "09": "Guayas",
  "10": "Imbabura",
  "11": "Loja",
  "12": "Los Rios",
  "13": "Manabi",
  "14": "Morona Santiago",
  "15": "Napo",
  "16": "Pastaza",
  "17": "Pichincha",
  "18": "Tungurahua",
  "19": "Zamora Chinchipe",
  "20": "Galapagos",
  "21": "Sucumbios",
  "22": "Orellana",
  "23": "Santo Domingo de los Tsachilas",
  "24": "Santa Elena"
};

function validarCedulaEcuador(cedulaParametro) {
  var cedula = String(cedulaParametro || "").replace(/\D/g, "");
  var codigoProvincia;
  var numeroProvincia;
  var digitos;
  var coeficientes;
  var suma;
  var i;
  var producto;
  var digitoVerificadorEsperado;
  var digitoVerificadorActual;

  if (!/^\d{10}$/.test(cedula)) {
    return {
      valido: false,
      mensaje: "La cedula debe tener exactamente 10 digitos."
    };
  }

  codigoProvincia = cedula.substring(0, 2);
  numeroProvincia = parseInt(codigoProvincia, 10);

  if (numeroProvincia < 1 || numeroProvincia > 24) {
    return {
      valido: false,
      cedula: cedula,
      codigoProvincia: codigoProvincia,
      mensaje: "Los dos primeros digitos no corresponden a una provincia valida."
    };
  }

  if (parseInt(cedula.charAt(2), 10) >= 6) {
    return {
      valido: false,
      cedula: cedula,
      codigoProvincia: codigoProvincia,
      provincia: provinciasEcuador[codigoProvincia],
      mensaje: "El tercer digito debe ser menor a 6 para cedulas de personas naturales."
    };
  }

  digitos = cedula.split("").map(function (digito) {
    return parseInt(digito, 10);
  });

  coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
  suma = 0;

  for (i = 0; i < coeficientes.length; i++) {
    producto = digitos[i] * coeficientes[i];

    if (producto >= 10) {
      producto = producto - 9;
    }

    suma = suma + producto;
  }

  digitoVerificadorEsperado = suma % 10 === 0 ? 0 : 10 - (suma % 10);
  digitoVerificadorActual = digitos[9];

  if (digitoVerificadorActual !== digitoVerificadorEsperado) {
    return {
      valido: false,
      cedula: cedula,
      codigoProvincia: codigoProvincia,
      provincia: provinciasEcuador[codigoProvincia],
      digitoVerificadorEsperado: digitoVerificadorEsperado,
      digitoVerificadorActual: digitoVerificadorActual,
      mensaje: "El digito verificador no coincide."
    };
  }

  return {
    valido: true,
    cedula: cedula,
    codigoProvincia: codigoProvincia,
    provincia: provinciasEcuador[codigoProvincia],
    digitoVerificador: digitoVerificadorActual,
    mensaje: "Cedula valida."
  };
}

export default validarCedulaEcuador;
export { validarCedulaEcuador };